// @flow

import { fromJS } from 'immutable';

export const GET_VIDEO_DETAILS = 'App/Play/GET_VIDEO_DETAILS';
export const GET_VIDEO_DETAILS_SUCCESS = 'App/Play/GET_VIDEO_DETAILS_SUCCESS';
export const GET_VIDEO_DETAILS_FAIL = 'App/Play/GET_VIDEO_DETAILS_FAIL';
export const CLEAR_VIDEO_DETAILS = 'App/Play/CLEAR_VIDEO_DETAILS';

export const SEND_SURVEY_ANSWER = 'App/Play/SEND_SURVEY_ANSWER';
export const SEND_SURVEY_ANSWER_SUCCESS = 'App/Play/SEND_SURVEY_ANSWER_SUCCESS';
export const SEND_SURVEY_ANSWER_FAIL = 'App/Play/SEND_SURVEY_ANSWER_FAIL';
export const CLEAR_SURVEY_ANSWER = 'App/Play/CLEAR_SURVEY_ANSWER';

const initialState = fromJS({
  getVideoDetailsLoading: false,
  videoDetails: {},
  getVideoDetailsFail: null,

  sendSurveyAnswerLoading: null,
  sendSurveyAnswerSuccess: {},
  sendSurveyAnswerFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_VIDEO_DETAILS:
      return state.merge({
        getVideoDetailsLoading: true,
        getVideoDetailsFail: null,
      });
    case GET_VIDEO_DETAILS_SUCCESS:
      return state.merge({
        getVideoDetailsLoading: false,
        videoDetails: fromJS(action.data),
      });
    case GET_VIDEO_DETAILS_FAIL:
      return state.merge({
        getVideoDetailsLoading: false,
        getVideoDetailsFail: fromJS(action.data),
      });
    case CLEAR_VIDEO_DETAILS:
      return state.set('videoDetails', fromJS({}));
    case SEND_SURVEY_ANSWER:
      return state.merge({
        sendSurveyAnswerLoading: action.data.id,
      });
    case SEND_SURVEY_ANSWER_SUCCESS:
      return state.merge({
        sendSurveyAnswerLoading: null,
        sendSurveyAnswerSuccess: fromJS(action.data),
      });
    case SEND_SURVEY_ANSWER_FAIL:
      return state.merge({
        sendSurveyAnswerLoading: null,
        sendSurveyAnswerFail: fromJS(action.data),
      });
    case CLEAR_SURVEY_ANSWER:
      return state.merge({
        sendSurveyAnswerLoading: null,
        sendSurveyAnswerSuccess: {},
        sendSurveyAnswerFail: null,
      });
    default:
      return state;
  }
};

export const getVideoDetails = (data : string) => (dispatch : any) =>
  dispatch({ type: GET_VIDEO_DETAILS, data });
export const clearVideoDetails = () => ({ type: CLEAR_VIDEO_DETAILS });

export const sendSurveyAnswer = (data : any) => (dispatch : any) =>
  dispatch({ type: SEND_SURVEY_ANSWER, data });
export const clearSurveyAnswer = () => ({ type: CLEAR_SURVEY_ANSWER });
